import { HttpUrlEncodingCodec } from "@angular/common/http";
export class UrlParameterEncodingCodec extends HttpUrlEncodingCodec {
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    encodeValue(value) {
        return encodeURIComponent(value);
    }
}
